import * as React from "react";
const SvgFiRrMedicalStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-medical-star_svg__a)">
      <path
        fill="#062147"
        d="M22.192 18.267a1 1 0 0 1-1.375.331l-7.858-4.812v9.215a1 1 0 1 1-2 0v-9.215L3.1 18.598a1 1 0 0 1-1.045-1.706L10.045 12l-7.99-4.892a.999.999 0 1 1 1.046-1.705l7.858 4.812V1a1 1 0 1 1 2 0v9.215l7.858-4.812a1 1 0 1 1 1.045 1.705L13.872 12l7.99 4.892a1 1 0 0 1 .33 1.375"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-medical-star_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMedicalStar;
